
import React, { createContext, useState, useEffect, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';

import Header from './components/Header';
import MobileAppBar from './components/MobileAppBar';

// // ✅ YAH ADD KIYA HAI (StatsSection import)
// import StatsSection from "./components/StatsSection";

import Footer from './components/Footer';
import BrandsDropdown from "./pages/BrandsDropdown";

// ✅ NEW IMPORT (Tumhara file)
import Havbitabout from './pages/Havbitabout.jsx';

import Home from './pages/Home';
import Products from './pages/Products';
import CategoryPage from './pages/CategoryPage';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Account from './pages/Account';
import Wishlist from './pages/Wishlist';
import SearchPage from './pages/SearchPage';
import Orders from './pages/Orders';
import OrderDetails from './pages/OrderDetails';
import Login from './pages/Login';
import Register from './pages/Register';

import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

import RefundPolicy from './pages/RefundPolicy';
import ContactUs from './pages/ContactUs';
import TermsAndConditions from './pages/TermsAndConditions';
import VendorShop from './pages/VendorShop';
import CityProductsPage from './components/CityProductsPage';
import RestaurantProductsPage from './pages/RestaurantProductsPage';
import MobileCategoryFlow from './components/MobileCategoryFlow';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ShippingPolicy from './pages/ShippingPolicy';
import PaymentPolicy from './pages/PaymentPolicy';
import CancellationPolicy from './pages/CancellationPolicy';
import CommunityGuidelines from './pages/CommunityGuidelines';
import CookiePolicy from './pages/CookiePolicy';
import GrievancePolicy from './pages/GrievancePolicy';
import IntellectualPropertyPolicy from './pages/IntellectualPropertyPolicy';
import BlogsPage from "./pages/BlogsPage";

// --- SCROLL TO TOP COMPONENT ---
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// --- CONDITIONAL LAYOUT WRAPPER ---
const LayoutWrapper = ({ children, cart, removeFromCart, updateQty, clearCart, wishlist, addToCart, removeFromWishlist, clearWishlist }) => {
  const location = useLocation();
  const hideHeaderFooter = location.pathname === '/login' || location.pathname === '/register';
  const hideFooter = hideHeaderFooter || ['/cart', '/checkout'].includes(location.pathname);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {!hideHeaderFooter && <Header />}

      <main className="flex-grow">
        <Routes>

          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/category/:categoryName" element={<CategoryPage />} />
          <Route path="/city/:citySlug" element={<CityProductsPage />} />
          <Route path="/categories" element={<MobileCategoryFlow />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/shipping-policy" element={<ShippingPolicy />} />
          <Route path="/payment-policy" element={<PaymentPolicy />} />
          <Route path="/cancellation-policy" element={<CancellationPolicy />} />
          <Route path="/community-guidelines" element={<CommunityGuidelines />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/grievance-policy" element={<GrievancePolicy />} />
          <Route path="/intellectual-property-policy" element={<IntellectualPropertyPolicy />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/:categorySlug" element={<Products />} />

          {/* About */}
          <Route path="/about" element={<Havbitabout />} />
          <Route
    path="/:categorySlug/:productSlug"
    element={<ProductDetail />}
/>
          <Route path="/product/:productSlug" element={<ProductDetail />} />
          <Route path="/restaurant-products/:restaurantName" element={<RestaurantProductsPage />} />
          <Route path="/vendor/:vendorId" element={<VendorShop />} />
          <Route path="/blogs" element={<BlogsPage />} />

          <Route path="/cart" element={
            <Cart
              cart={cart}
              removeFromCart={removeFromCart}
              updateQty={updateQty}
              clearCart={clearCart}
            />
          } />

          <Route path="/search" element={<SearchPage />} />
          <Route path="/account" element={<Account />} />

          <Route path="/wishlist" element={
            <Wishlist
              wishlist={wishlist}
              addToCart={addToCart}
              removeFromWishlist={removeFromWishlist}
              clearWishlist={clearWishlist}
              cart={cart}
              updateQty={updateQty}
              removeFromCart={removeFromCart}
            />
          } />

          {/* Auth */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Protected */}
          <Route path="/checkout" element={
            <ProtectedRoute>
              <Checkout cart={cart} clearCart={clearCart} />
            </ProtectedRoute>
          } />

          <Route path="/orders" element={
            <ProtectedRoute>
              <Orders />
            </ProtectedRoute>
          } />

          <Route path="/order/:id" element={
            <ProtectedRoute>
              <OrderDetails />
            </ProtectedRoute>
          } />

          <Route path="/orders/:orderId" element={
            <ProtectedRoute>
              <OrderDetails />
            </ProtectedRoute>
          } />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>

      {!hideHeaderFooter && <BrandsDropdown />}
      {/* 🔥 YEH LINE ADD KAR */}
{/* {!hideHeaderFooter && <StatsSection />} */}
      {!hideFooter && <Footer />}
      {!hideHeaderFooter && <MobileAppBar />}
    </div>
  );
};

// बाकी code same

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};

function AppContent() {
  const [cart, setCart] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [selectedHomeCategory, setSelectedHomeCategory] = useState(null);

  useEffect(() => {
    const savedCart = JSON.parse(localStorage.getItem('havbit_cart') || '[]');
    const savedWishlist = JSON.parse(localStorage.getItem('havbit_wishlist') || '[]');
    setCart(savedCart);
    setWishlist(savedWishlist);
  }, []);

  useEffect(() => {
    localStorage.setItem('havbit_cart', JSON.stringify(cart));
  }, [cart]);

  useEffect(() => {
    localStorage.setItem('havbit_wishlist', JSON.stringify(wishlist));
  }, [wishlist]);

  const addToCart = (product, quantity = 1) => {
    setCart(prevCart => {
      const existingItem = prevCart.find(item => item._id === product._id);
      if (existingItem) {
        return prevCart.map(item =>
          item._id === product._id ? { ...item, qty: (item.qty || 1) + quantity } : item
        );
      } else {
        return [...prevCart, { ...product, qty: quantity }];
      }
    });
  };

  const updateQty = (productId, quantity) => {
    setCart(prevCart =>
      prevCart.map(item =>
        item._id === productId ? { ...item, qty: Math.max(0, quantity) } : item
      ).filter(item => item.qty > 0)
    );
  };

  const removeFromCart = (productId) => {
    setCart(prevCart => prevCart.filter(item => item._id !== productId));
  };

  const clearCart = () => setCart([]);

  const toggleWishlistItem = (product) => {
    setWishlist(prevWishlist => {
      const exists = prevWishlist.find(item => item._id === product._id);
      return exists
        ? prevWishlist.filter(item => item._id !== product._id)
        : [...prevWishlist, product];
    });
  };

  const removeFromWishlist = (productId) => {
    setWishlist(prevWishlist => prevWishlist.filter(item => item._id !== productId));
  };

  const clearWishlist = () => setWishlist([]);

  return (
    <CartContext.Provider value={{
      cart, addToCart, updateQty, removeFromCart, clearCart,
      wishlist, toggleWishlistItem, removeFromWishlist, clearWishlist,
      selectedHomeCategory, setSelectedHomeCategory
    }}>
      <Router>
        <ScrollToTop />
        <LayoutWrapper
          cart={cart}
          removeFromCart={removeFromCart}
          updateQty={updateQty}
          clearCart={clearCart}
          wishlist={wishlist}
          addToCart={addToCart}
          removeFromWishlist={removeFromWishlist}
          clearWishlist={clearWishlist}
        />
      </Router>
    </CartContext.Provider>
  );
}

function App() {
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;